'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ThemeProvider = require('./ThemeProvider');

var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectStylingById = function selectStylingById(id, themes) {
    return themes[id] || themes.default;
};

var mergeThemes = function mergeThemes(whitelabel, local) {
    var merged = {};
    var allThemes = (0, _keys2.default)(whitelabel).concat((0, _keys2.default)(local));

    allThemes.forEach(function (theme) {
        merged[theme] = (0, _extends3.default)({}, whitelabel.default, local.default, whitelabel[theme], local[theme]);
    });

    return merged;
};

var SelectedThemeProvider = function SelectedThemeProvider(_ref) {
    var id = _ref.id,
        whitelabelThemesMapping = _ref.whitelabelThemesMapping,
        localThemesMapping = _ref.localThemesMapping,
        irisStyles = _ref.irisStyles,
        children = _ref.children;

    var mergedThemes = mergeThemes(whitelabelThemesMapping, localThemesMapping);

    var activeTheme = selectStylingById(id, mergedThemes);
    var activeStyling = selectStylingById(id, irisStyles);

    return _react2.default.createElement(
        _ThemeProvider2.default,
        { theme: activeTheme, styling: activeStyling },
        children
    );
};

var themeType = _propTypes2.default.shape({
    default: _propTypes2.default.object
});

SelectedThemeProvider.propTypes = {
    id: _propTypes2.default.string,
    whitelabelThemesMapping: themeType,
    localThemesMapping: themeType,
    irisStyles: themeType,
    children: _propTypes2.default.node.isRequired
};

SelectedThemeProvider.defaultProps = {
    id: 'default',
    whitelabelThemesMapping: {},
    localThemesMapping: {},
    irisStyles: {}
};

exports.default = SelectedThemeProvider;
//# sourceMappingURL=SelectedThemeProvider.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/roc-package-hyperion/~/@spp/theme-provider/lib/cjs/SelectedThemeProvider.js
 ** module id = 551
 ** module chunks = 1
 **/